import React, { ReactNode } from 'react';
import { DatePicker, Input } from 'antd';
import { SignUpFormItem } from 'store/ducks/Global/types';

const userAccessFormItems = (t: (key: string) => string): SignUpFormItem[] => [
  {
    type: 'text',
    label: t('USERNAME'),
    name: 'username',
    rules: [{ required: true }]
  },
  {
    type: 'text',
    label: t('FIRST_NAME'),
    name: 'firstName',
    rules: [{ required: true }]
  },
  {
    type: 'text',
    label: t('LAST_NAME'),
    name: 'lastName',
    rules: [{ required: true }]
  },
  {
    type: 'text',
    label: t('DEPARTMENT'),
    name: 'department'
  },
  {
    type: 'text',
    label: t('MIDDLE_NAME'),
    name: 'middleName'
  },
  {
    type: 'email',
    label: t('EMAIL_ADDRESS'),
    name: 'email',
    rules: [{ required: true }]
  },
  {
    type: 'password',
    label: t('PASSWORD'),
    name: 'password',
    rules: [{ required: true }],
    render: () => <Input.Password visibilityToggle />
  },
  {
    type: 'password',
    label: t('CONFIRM_PASSWORD'),
    name: 'confirmPassword',
    rules: [
      { required: true, message: t('CONFIRM_PASSWORD_MSG') },
      ({ getFieldValue }) => ({
        validator(_, value) {
          const allValues = getFieldValue([]);
          const formIndex = Object.keys(allValues || {}).find(
            (key) => allValues[key]?.confirmPassword === value
          );

          if (
            !value ||
            getFieldValue([Number(formIndex), 'password']) === value
          ) {
            return Promise.resolve();
          }

          return Promise.reject(new Error(t('PASSWORDS_NO_MATCH')));
        }
      })
    ],
    render: () => <Input.Password visibilityToggle />
  },
  {
    type: 'custom',
    label: t('DEACTIVATION_DATE'),
    name: 'deactivation_date',
    render: () => <DatePicker />
  }
];

export default userAccessFormItems;
